import React from "react";
import { useSelector } from "react-redux";
import { FiCalendar } from "react-icons/fi";
import ServicePlanPage from "../components/options/ServicePlanPage";
import { adminGuide } from "../components/guide/guideContent";
import pricing from "../assets/data/pricing.json";
import { adminPrices } from "../utils/serviceFlows";

function PlatformAdmin() {
  const cart = useSelector((state) => state.cart);
  const turnover = cart?.turnover || cart?.company?.turnover || 0;

  return (
    <ServicePlanPage
      serviceKey="platformAdmin"
      icon={FiCalendar}
      title={
        <>
          L'<span>administration</span> de votre entreprise
        </>
      }
      lead="Télédéclarations, DSF et cotisations sociales : nous gérons vos obligations administratives pour vous."
      cardTitle="Administration d'entreprise"
      summary="Un suivi rigoureux de vos obligations fiscales et sociales, dans le respect des échéances."
      prices={adminPrices(pricing.platformAdmin, turnover)}
      guide={adminGuide}
      note="Le tarif dépend du chiffre d'affaires annuel de votre entreprise."
    />
  );
}

export default PlatformAdmin;
